export default __webpack_public_path__ + "static/toolsMotions-5b8d3de3af423eab16ed79b8018dba90.png";